const RejectReasonModal = ({ reason }) => {
    return (
        <>
            <div
                className="modal fade m-0 p-0"
                tabIndex={-1}
                id={`reject-reason-modal`}
                aria-modal
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <button className="close" data-bs-dismiss="modal">
                            <em
                                className="icon ni ni-cross"
                                aria-hidden="true"
                            ></em>
                        </button>
                        <div className="modal-header">
                            <h5 className="modal-title">Rejection Reason</h5>
                        </div>
                        <div className="modal-body">
                            <div className="row g-4">
                                <div className="col-12">{reason ?? ""}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button
                type="button"
                className="btn btn-sm btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#reject-reason-modal"
            >
                Reason
            </button>
        </>
    );
};

export default RejectReasonModal;
